package fr.frux.feature.treeadd.wizard

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxButtonStyle
import fr.frux.feature.treeadd.resources.Res
import fr.frux.feature.treeadd.resources.wizard_exit_body
import fr.frux.feature.treeadd.resources.wizard_exit_continue
import fr.frux.feature.treeadd.resources.wizard_exit_quit
import fr.frux.feature.treeadd.resources.wizard_exit_title
import fr.frux.feature.treeadd.resources.wizard_lost_and
import fr.frux.feature.treeadd.resources.wizard_lost_note
import fr.frux.feature.treeadd.resources.wizard_lost_photos
import fr.frux.feature.treeadd.resources.wizard_lost_species
import fr.frux.feature.treeadd.resources.wizard_lost_status
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource

/** Confirmation de sortie : dit précisément ce qui ne sera pas gardé, l'espèce en premier. */
@Composable
internal fun WizardExitDialog(
    lost: LostInputs,
    onQuit: () -> Unit,
    onContinue: () -> Unit,
) {
    val parts =
        buildList {
            if (lost.species) add(stringResource(Res.string.wizard_lost_species))
            if (lost.status) add(stringResource(Res.string.wizard_lost_status))
            if (lost.photoCount > 0) {
                add(pluralStringResource(Res.plurals.wizard_lost_photos, lost.photoCount, lost.photoCount))
            }
            if (lost.note) add(stringResource(Res.string.wizard_lost_note))
        }
    AlertDialog(
        onDismissRequest = onContinue,
        containerColor = MaterialTheme.colorScheme.surfaceContainerHigh,
        shape = RoundedCornerShape(28.dp),
        title = {
            Text(stringResource(Res.string.wizard_exit_title), style = MaterialTheme.typography.headlineMedium)
        },
        text = {
            Text(
                text =
                    stringResource(
                        Res.string.wizard_exit_body,
                        joinLost(parts, stringResource(Res.string.wizard_lost_and)),
                    ),
                style = MaterialTheme.typography.bodyMedium,
            )
        },
        dismissButton = {
            FruxButton(
                text = stringResource(Res.string.wizard_exit_quit),
                onClick = onQuit,
                style = FruxButtonStyle.DestructiveText,
            )
        },
        confirmButton = {
            FruxButton(text = stringResource(Res.string.wizard_exit_continue), onClick = onContinue)
        },
    )
}
